export default customElements.define('w-card', class Card extends wealthify.CustomElementBaseClass {

    constructor () {
        const styleSelector = 'c-card';
        const config = {
            templateHTML: `<div class="${styleSelector}__root" data-root>
                <div class="${styleSelector}__ribbon" data-ribbon></div>
                <div class="${styleSelector}__container" data-container>
                    <div class="${styleSelector}__content u-display__none" data-child-root></div>
                    <span class="${styleSelector}__segment u-display__none" data-slot="segment" data-slot-multiple data-segment></span>
                    <span class="${styleSelector}__footer u-display__none" data-slot="footer" data-footer></span>
                </div>
                <w-button-2 class="${styleSelector}__dismiss-button" label="Dismiss" no-label="true" iconleft="cross" variant="secondary" is-inline-mobile="true" data-dismiss-button></w-button-2>
            </div>`,
            hasChildren: true,
            cacheDom: [
                'data-ribbon', 'data-container', 'data-child-root', 'data-footer', 'data-root', 'data-dismiss-button'
            ]
        };

        super(config);

        this.onConnectedCallback = () => {
            if (this.#isContentAdded) {
                this.dom.childRoot.classList.remove('u-display__none');
            }

            this.#originalType = this.type;

            // TODO - Remove after slot refactor (PDB-1008)
            if (this.#areSegmentsSlotted) {
                const segments = Array.isArray(this.dom.segment) ? this.dom.segment : [this.dom.segment];

                segments.forEach(segment => segment.classList.remove('u-display__none'));

                if (this.#isContentAdded) {
                    segments[0].classList.add('u-border__type-top-mobile--solid');
                }
            }

            if (this.#isFooterSlotted) {
                this.dom.footer.classList.remove('u-display__none');
            }

            this.dom.dismissButton.addEventListener('click', this.events.Dismissed.dispatch);
        };
    }

    // Static

    static styleSelector = 'c-card';

    static get observedProps () {
        return [
            new wealthify.Prop('link'),
            new wealthify.Prop('size', {
                default: wealthify.enumsLocal.sizes.Medium,
                type: wealthify.propTypes.ArrayItem(Object.values(wealthify.enumsLocal.sizes))
            }),
            new wealthify.Prop('type', {
                default: 'default',
                type: wealthify.propTypes.ArrayItem(this.validTypes)
            }),
            new wealthify.Prop('ribbon', {default: ''}),
            new wealthify.Prop('hasribbonpadding', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('cover-image-side'),
            new wealthify.Prop('cover-image-top'),
            new wealthify.Prop('dismissible', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('disabled-prop', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
        ];
    }

    static get validTypes () {
        return ['default', 'highlight' ];
    }

    static extensions = [
        wealthify.componentExtensions.Surface
    ]

    static get eventSettings () {
        return {
            events: { Dismissed: 'dismissed'},
            subscriptions: {[wealthify.ComponentEvents.globalEvents.DisabledToggled]: this.prototype.toggleDisabledFromCustomEvent}
        };
    }

    // Public

    get propCallbacks () {
        return {
            link: () => {

                if (this.link === '') {

                    if (this.dom.link === undefined) {
                        return;
                    }

                    wealthify.dom.moveContentBetweenNodes(this.dom.link, this.dom.root);
                    this.dom.root.removeChild(this.dom.link);
                    delete this.dom.link;

                } else {
                    this.#wrapContentInLink();
                }

            },
            size: () => {
                Object.values(wealthify.enumsLocal.sizes).forEach((size) => this.classList.remove(`${this.styleSelector}--size-${size}`));
                this.classList.add(`${this.styleSelector}--size-${this.size}`);
            },
            type: () => {
                this.constructor.validTypes.forEach((type) => this.classList.remove(`${this.styleSelector}--type-${type}`));
                this.classList.add(`${this.styleSelector}--type-${this.type}`);
            },
            ribbon: () => {
                const displayClassListAction = this.ribbon === '' ? 'add' : 'remove';

                this.dom.ribbon.textContent = this.ribbon;
                this.dom.ribbon.classList[displayClassListAction]('u-display__none');
                this.#updateRibbonPaddingClasses();
                this.#updateRibbonDisplayClass();
            },
            hasribbonpadding: () => {
                this.#updateRibbonPaddingClasses();
            },
            coverImageSide: () => this.#addCoverImage('side', this.coverImageSide),
            coverImageTop: () => this.#addCoverImage('top', this.coverImageTop),
            dismissible: () => {
                const classListAction = this.dismissible ? 'remove' : 'add';

                this.dom.dismissButton.classList[classListAction]('u-display__none');
                this.dom.dismissButton.disabledProp = !this.dismissible;
            },
            disabledProp: () => {
                const classListAction = this.disabledProp ? 'add' : 'remove';

                this.classList[classListAction](`${this.styleSelector}--disabled`);
            }
        };
    }

    toggleDisabledFromCustomEvent (data) {
        this.disabled = data.detail ? 'true' : 'false';
    }

    // Private

    #originalType;

    get #isContentAdded() {
        return this.dom.childRoot.childNodes.length > 0;
    }

    // TODO - Remove after slot refactor (PDB-1008)
    get #areSegmentsSlotted() {
        const segments = Array.isArray(this.dom.segment) ? this.dom.segment : [this.dom.segment];

        return segments.every(segment => segment.tagName.toLowerCase() !== 'span');
    }

    get #isFooterSlotted(){
        return this.dom.footer.tagName.toLowerCase() !== 'span';
    }

    #wrapContentInLink () {
        const link = document.createElement('a');

        link.setAttribute('href', this.link);
        link.classList.add(`${this.styleSelector}__link`);
        link.setAttribute('data-link', '');

        wealthify.dom.moveContentBetweenNodes(this.dom.root, link);
        this.dom.root.appendChild(link);
        this.dom.link = link;
    }

    #updateRibbonPaddingClasses () {
        const paddingClass = 'u-padding__top-mobile--layout-xs';

        if (this.ribbon !== '' || this.hasribbonpadding) {
            this.dom.container.classList.add(paddingClass);

            return;
        }

        this.dom.childRoot.classList.remove(paddingClass);
    }

    #addCoverImage (variant, value) {
        let coverImageElement = this.dom.coverImage;

        if (!coverImageElement) {
            coverImageElement = document.createElement('div');
        }

        coverImageElement.style.setProperty(`--background-image-${variant}`, `url(${value})`);
        coverImageElement.classList.add(`${this.styleSelector}__cover-image`, `${this.styleSelector}__cover-image--${variant}`);
        coverImageElement.dataset.coverImage = '';
        this.dom.childRoot.classList.add(`${this.styleSelector}__content--has-cover-image-${variant}`);
        this.dom.container.classList.add(`${this.styleSelector}__container--has-cover-image`);

        this.dom.childRoot.appendChild(coverImageElement);
    }

    #updateRibbonDisplayClass () {
        const allClassListAction = this.ribbon === '' ? 'add' : 'remove';

        this.dom.ribbon.classList[allClassListAction]('u-display__none');
    }

});